import { isStandalone } from '../store/installStore'

/**
 * Two ways to open parrots.club, decided once per page load:
 *
 *   app mode  — the installed web app (standalone display mode): the
 *               practice product, exactly as before — lessons, feed,
 *               progress, the AppShell.
 *   site mode — a browser tab: the public website. Signing in here is
 *               for the account only (owner's rule, 2026-09-19): buying
 *               or managing the subscription, the profile, support. It
 *               never opens the practice screens; those are the app's.
 *
 * So the same URL space serves both, keyed on how the page was opened
 * rather than on who is signed in. A learner who wants to practise from
 * a browser installs the web app (the download page) and gets app mode.
 */
export function isSiteMode() {
  return !isStandalone()
}

/** Where sign-in lands: an explicit origin, else the account hub on the site and the lessons in the app. */
export function postLoginDestination(from, site = isSiteMode()) {
  if (typeof from === 'string' && from.startsWith('/')) return from
  return site ? '/account' : '/dashboard'
}

/** The practice routes that only the app serves; on the site they resolve to the account hub. */
export const APP_ONLY_PATHS = [
  '/dashboard',
  '/lessons',
  '/lessons/all',
  '/lesson/:lessonId',
  '/social',
  '/leaderboard',
  '/progress',
  '/notifications',
  '/shop',
  '/settings',
  '/alerts',
  '/archive',
  '/archive/:attemptId',
]
